import {createProperty} from './utils/createProperty'

/**
 * The annotation builder for a component property with type 'Time'.
 */
export const time = createProperty('time').typed('time')
